import React from "react";
import {SharedInputControl} from "../DerivedControls";
import PropTypes from "prop-types";

export default function TimePickerInput({
  value,
  onChange,
  errors,
  errorPath,
  isSubmitted,
  labelValue,
  parentTranslationPath,
}) {
  return (
    <form noValidate>
      <SharedInputControl
        isFullWidth
        editValue={value}
        onValueChanged={(newValue) => onChange(newValue.value)}
        stateKey="time"
        // isDisabled
        idRef="time"
        errors={errors}
        errorPath={errorPath}
        isSubmitted={isSubmitted}
        InputLabelProps={{
          shrink: true,
          required: true,
        }}
        type="time"
        step={900} // 5 min
        isNotCenter
        labelValue={labelValue}
        parentTranslationPath={parentTranslationPath}
      />
    </form>
  );
}

TimePickerInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  errors: PropTypes.shape({}),
  errorPath: PropTypes.string,
  isSubmitted: PropTypes.bool,
  labelValue: PropTypes.string,
  parentTranslationPath: PropTypes.string,
};
TimePickerInput.defaultProps = {
  parentTranslationPath: "",
};
